// extracted by mini-css-extract-plugin
module.exports = {"box":"KtBox_box__1mjHD","box-ltr":"KtBox_box-ltr__efl3F","square":"KtBox_square__2uLI9","circle":"KtBox_circle__1HNOC","diamond":"KtBox_diamond__1hE19","text":"KtBox_text__OinwT"};